module.exports = __webpack_public_path__ + "media/images/games/clash-royale/logo-08a176d72629fd88cf00e302a12b1791.png";